<template>
    <div class="form-group">
        <label>Cerca indirizzo</label>
        <autocomplete
            v-model="selectedPrediction"
            :fetchFn="fetchPredictions"
            :labelFn="(item) => item.description"
            @update:modelValue="onPredictionSelected"
        >
            <template #item="{ item, highlight }">
                <span v-html="highlight(item.description)"></span>
            </template>
        </autocomplete>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options } from 'vue-class-component';
import * as OM from '@/model';
import { GooglePlacesClient } from '@/services/Services';

@Options({})
export default class GoogleAutocomplete extends mixins(WithModel) {

    selectedPrediction: OM.PlacePredictionVm | null = null;

    fetchPredictions(input: string): Promise<OM.PlacePredictionVm[]> {
        if (!input || input.length < 2)
            return Promise.resolve([]);
        return GooglePlacesClient.autocomplete(input, false);
    }

    async onPredictionSelected(prediction: OM.PlacePredictionVm | null) {
        if (!prediction?.placeId)
            return;

        const address = await GooglePlacesClient.placeDetails(prediction.placeId, false);
        this.emitModel(address);
        this.$nextTick(() => {
            this.selectedPrediction = null;
        });
    }
}
</script>
